import { createContext, useContext } from 'react';
import type { CheckoutVariant } from './useBilling';

export interface BillingModalsApi {
  openPlan: () => void;
  openCheckout: (variant: CheckoutVariant) => void;
}

/** Provided by the shell (component/BillingModals), so a CTA anywhere opens
 * the same plan and checkout modals. */
export const BillingModalsContext = createContext<BillingModalsApi | null>(null);

export function useBillingModals(): BillingModalsApi {
  const api = useContext(BillingModalsContext);
  if (!api) throw new Error('useBillingModals needs a BillingModals provider');
  return api;
}
